import React, { useState, useEffect, useRef } from 'react';
import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
// import Slider from "react-slick";
import { Link } from 'react-router-dom';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';
import { Dropdown, Tab, Tabs, Button, Form } from 'react-bootstrap';
import Docmnt from '../../../../assets/images/google-docs.png';
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Trash from '../../../../assets/images/trash.png';
import Cargoplane from "../../../../assets/images/plane.svg";
// import Cuser from "../../../../assets/images/cuser.png";
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Badge from 'react-bootstrap/Badge';
import ImageUpload from '../../../../Components/common/ImageUpload.js';
import ActivityComments from '../../../../Components/common/ActivityComments.js';
import EditUld from '../components/EditUld.js';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { ULDASSETSGRID, GETDAMAGETYPE, UPDATESTATUS, UPDATECONDITION, GETULDDETAILS, MOVETOACTARC, DOWNLOADULD, GETTYPECODE, GETDESTINATION, GETCONDITIONCODE, GETOWNERCODE, MVTHDETAILS, RECMISSING } from '../../../../Utils/conts.js';
import Loader from '../../../../Components/common/Loader.js';
import DownloadGrid from '../components/DownloadGrid.js';
import { forEach } from 'lodash';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const LUCIn = ({ linkClick = '' }) => {

    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const isMounted = useRef(false);
    const [filterApplied, setFilterApplied] = useState(false);

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);


    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [activeTab, setActiveTab] = useState('Active');

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'trip_no', type: 'string' },
                    { name: 'uld_ids', type: 'string' },
                    { name: 'ulds', type: 'string' },

                    { name: 'transfer_date', type: 'string' },
                    { name: 'transfer_point', type: 'string' },
                    { name: 'luc_message', type: 'string' },
                    { name: 'received_by_name', type: 'string' },
                    { name: 'received_by', type: 'string' },
                    { name: 'control_receipt_no', type: 'string' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}handler-luc/list?type=${tabType}&tab=luc_in`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                },
                { text: 'Trip No.', filtertype: 'textbox', datafield: 'trip_no', width: '12%', cellclassname: '', },
                { text: 'Transfer Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'transfer_date', width: '12%', cellclassname: '', },
                { text: 'Transfer Point', filtertype: 'input', datafield: 'transfer_point', width: '12%', cellclassname: '', },
                {
                    text: 'Returned By', filtertype: 'input', datafield: 'received_by_name', width: '12%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.received_by) {
                            return '<div class="jqx-grid-cell-left-align set_dock ">' + rowdata.received_by.agent_name + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align set_dock "></div>';
                        }
                    },
                },
                {
                    text: 'Control Receipt No.', filtertype: 'input', datafield: 'control_receipt_number', width: '12%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata?.luc_message?.length) {
                            const num = rowdata?.luc_message?.map(n => n.control_receipt_number)
                            
                            return '<div class="jqx-grid-cell-left-align set_dock ">' + num + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align set_dock "></div>';
                        }
                    }
                },
                // {
                //     text: 'ULDs Count', filtertype: 'textbox', datafield: 'type_code', width: '12%', cellclassname: '',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         if (rowdata.ulds.length) {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">'+ rowdata.ulds.length +'</div>';
                //         } else {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">0</div>';
                //         }
                //     },
                // },
                // { text: 'Receipt', filtertype: 'textbox', datafield: 'serial_number', width: '12%', cellclassname: '', },
                // { text: 'Status', filtertype: 'textbox', datafield: 'owner_code', width: '5%', cellclassname: '', },
                // {
                //     text: 'Condition Code', filtertype: 'checkedlist', filterable: true,
                //     filteritems: [
                //         { label: 'Serviceable', value: 'SER' },
                //         { label: 'Damaged', value: 'DAM' },
                //         { label: 'Discarded', value: 'DIS' }
                //     ],
                //     datafield: 'condition', width: '7%', cellclassname: '',
                // },
                // {
                //     text: 'Mismatch', filtertype: 'checkedlist', datafield: 'mvt_status', width: '6%', cellclassname: '',
                //     filteritems: [
                //         { label: 'Yes', value: 'yes' },
                //         { label: 'No', value: 'no' },
                //     ],

                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue) {
                //             defaultHtml = "<div style='margin-left:18px;line-height: 38px;margin-top: 10px;'><span style='color: #d12828;font-weight:600;width:20px;height:20px;display: block;background: #fff;text-align: center;line-height: 17px;border: 2px solid #d12828;border-radius: 10px;font-size: 12px;'>! </span></div>";
                //         }
                //         return (
                //             defaultHtml
                //         );
                //     },
                // },
                // {
                //     text: 'Status', filtertype: 'checkedlist',
                //     filteritems: [
                //         { label: 'In Operation', value: '1' },
                //         { label: 'On Air', value: '4' },
                //         { label: 'On Loan', value: '5' },
                //         { label: 'Repair', value: '2' },
                //         { label: 'In Reserve', value: '3' },
                //         { label: 'Missing', value: '17' },

                //     ],

                //     datafield: 'status', width: '12%', cellclassname: '',
                // },
                // { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '5%', cellclassname: '', },
                // { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '', },
                // { text: 'Agent Name', filtertype: 'textbox', datafield: 'handler_name', width: '12%', cellclassname: '', },
                // { text: 'Station Agent', filtertype: 'textbox', datafield: 'scm', width: '12%', cellclassname: '', },

                // {
                //     text: 'Asset Type', filtertype: 'checkedlist',
                //     filteritems: [
                //         { label: 'Owned', value: 'Y' },
                //         { label: 'Lease', value: 'N' },
                //     ],
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         if (rowdata.asset_type === 'Y') {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">Owned</div>';
                //         } else {
                //             return '<div class="jqx-grid-cell-left-align set_dock ">Lease</div>';
                //         }
                //     },
                //     datafield: 'asset_type', width: '6%', cellclassname: '',
                // },
                // { text: 'Airline Name', filtertype: 'textbox', datafield: 'airline_name', width: '10%', cellclassname: '', },
                // { text: 'Warehouse', filtertype: 'textbox', datafield: 'awb_number', width: '14%', cellclassname: '', },
            ];

            const nestedColumns = [
                { text: 'ULD No.', datafield: 'uld_number', width: '10%' },
                { text: 'Type Code', datafield: 'type_code', width: '8%' },
                { text: 'Serial No.', datafield: 'serial_number', width: '8%' },
                { text: 'Owner Code', datafield: 'owner_code', width: '8%' },
                { text: 'Condition Code', datafield: 'condition', width: '10%' },
                // { text: 'Accepted By', datafield: 'accepted_by', width: '20%' },
                // { text: 'Accepted On', datafield: 'accepted_on', width: '20%' },   
            ];


            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                console.log(dataAdapter);
                const id = record?.uid?.toString();
                const uldGrid = dataAdapter?.loadedData?.Rows[id]?.ulds;

                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'uld_number', type: 'string' },
                        { name: 'type_code', type: 'string' },
                        { name: 'serial_number', type: 'string' },
                        { name: 'owner_code', type: 'string' },
                        { name: 'condition', type: 'string' },
                        { name: 'condition_code', type: 'string' },
                    ],
                    localdata: uldGrid,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: '',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

                window.$(nestedGridContainer).on('cellendedit', (event) => {
                    const args = event.args;
                    const rowData = args.row.bounddata;

                    if (args.datafield === 'select') {
                        // setGridNestedSelect(prevState => {
                        //     if (args.value) {
                        //         return [...prevState, rowData];
                        //     } else {
                        //         return prevState.filter(row => row.id !== rowData.id);
                        //     }
                        // });
                    }
                });

                // window.$(gridElement).on('rowselect', function (event) {
                //     const selectedRowIndex = event.args.rowindex;
                //     const rowDiv = window.$(this).closest('[role="row"]');
                //     const rowIndex = window.$(rowDiv).attr('row-id');
                //     // console.log("🚀 ~ rowDiv:", rowDiv)
                //     if (selectedRowIndex === index) {
                //         if (nestedGridContainer) {
                //             // Select all rows in the nested grid
                //             console.log("🚀 ~ window.$ ~ nestedGridContainer:", nestedGridContainer[index])
                //             const nestedRows = window.$(nestedGridContainer).jqxGrid('getrows');
                //             console.log("🚀 ~ window.$ ~ nestedRows:", nestedRows)
                //             for (let i = 0; i < nestedRows.length; i++) {
                //                 window.$(nestedGridContainer).jqxGrid('selectrow', i);
                //             }
                //         }
                //     }
                // });
                // window.$(gridElement).on('rowunselect', function (event) {
                //     const unselectedRowIndex = event.args.rowindex;
                //     if (unselectedRowIndex === index) {
                //         if (nestedGridContainer) {
                //             // Deselect all rows in the nested grid
                //             const nestedRows = window.$(nestedGridContainer).jqxGrid('getrows');
                //             for (let i = 0; i < nestedRows.length; i++) {
                //                 window.$(nestedGridContainer).jqxGrid('unselectrow', i);
                //             }
                //         }
                //     }
                // });
                window.$(nestedGridContainer).on('rowselect', (event) => {
                    console.log("🚀 ~ window.$ ~ event:00000000", event)
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        if ('uld_number' in selectedRow) {
                            const selectedRowId = selectedRow.uid;
                            // if (!gridNestedSelect.some(row => row.uid === selectedRowId)) {
                            //     // setGridNestedSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                            //     // setGridSelect(selectedRow);
                            // }
                        }
                    } else {
                        const whgrid = event.target.id;
                        console.log("🚀 ~ window.$ ~ wh nested", whgrid)
                        if (whgrid.includes("nestedGrid")) {
                            if (event.args.rowindex.length > 0) {
                                const allIds = uldGrid; // gridData[id].uld_level;
                                // setGridNestedSelect(allIds);
                            } else {
                                // setGridNestedSelect([]);
                            }
                        }
                    }
                });

                window.$(nestedGridContainer).on('rowunselect', (event) => {
                    // console.log("🚀 ~ window.$ ~ event:1111", event.args.row)
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.uld_number;
                        console.log("🚀 ~ window.$ ~ unselectedRowId:", unselectedRowId)
                        // setGridNestedSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                        // setGridNestedSelect([]);
                    }
                });

            };

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (10 * 45),
                    rowdetailshidden: true,
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('rowData', rowData);
                        editLUC(rowData);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 2) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails(args.uld_number);
                }
            });
        }
    }, [gridData]);

    const editLUC = (rowData) => {
        const keysToRemove = ['SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out'];
        keysToRemove.forEach(key => localStorage.removeItem(key));
        const {
            transfer_date = null,
            transfer_point = null,
            received_by = null,
        } = rowData;
        const filtered = { transfer_date, transfer_point, received_by: received_by?.id };
        const storageData = { ULD: rowData.ulds, Form: filtered, group_id: rowData.group_id, id: rowData.id };
        localStorage.setItem('LUC In', JSON.stringify(storageData));
        localStorage.setItem('HULD', 'luc');
        localStorage.setItem('HULDtab', 'li');
        linkClick('UF')
    }

    const loadDetails = async (uldNumber, pos) => {
        setDisLoading(true)
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)

                    setDisLoading(false)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);

    };

    const columnsToExport = {
        // uld_number: 'ULD Number',
        type_code: 'Type Code',
        // serial_number: 'Serial Number',
        owner_code: 'Owner Code',
        condition_code: 'Condition Code',
        status: 'Status',
        origin: 'Origin',
        destination: 'Destination',
        // scm: 'SCM',
        // scm_date: 'SCM Date',
        // asset_type: 'Asset Type',
        // handler_name: 'Handler Name',
        // airline_name: 'Airline Name',
        // Add more columns here if needed
    };
    const handleColumnChange = (columnKey) => {
        setSelectedColumns(prevSelected =>
            prevSelected.includes(columnKey)
                ? prevSelected.filter(key => key !== columnKey)
                : [...prevSelected, columnKey]
        );
    };


    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider

    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFile('');
    };



    const handleDropdownItemClick = (pos, action) => {

    };

    const [conditionChange, setConditionChange] = useState('Serviceable');
    const [actArcModal, setActArcModal] = useState(false);

    const handleConditionRadioChange = (e) => {

        setConditionChange(e.target.value);
    };

    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'R' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.uld_id)
        try {
            const res = await withRFSToken.post(MOVETOACTARC, { uld_numbers: uldNumbers, action: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        setActArcModal(false)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    // upload Section
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }
    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }
        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id, group_id: history.group_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };
    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };

    const goRecovery = (src) => {
        if (src == 'missing') {
            localStorage.setItem('Rtab', 'missing');
            window.location.href = '/Recovery'
        } else if (src == 'inactive') {
            localStorage.setItem('Rtab', 'inactive');
            window.location.href = '/Recovery'
        }
    }

    return (
        <>
            {/* {console.log('kol', gridSelect)}{console.log('new ids', checkUlds)} */}
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {downloadOpen && <DownloadGrid download_sec={activeTab} onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation')}>Finalize-LUC in</Dropdown.Item>
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('On Air')}>On Air</Dropdown.Item> */}
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Repair In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair Out')}>Repair Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Reserve')}>In Reserve</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Lease Out')}>Lease Out</Dropdown.Item> */}
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('Lease In')}>Lease In</Dropdown.Item> */}
                            {/* <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'SCM')}>SCM</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Missing')}>Missing</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className='ulddown'>
                {activeTab == 'Active' ? (
                    <>
                        <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>
                        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                    </>
                ) : (
                    <>
                        <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>
                        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                    </>
                )
                }

            </div>

            <div className="maindiv">
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Operation')}>In Operation</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair In')}>Repair In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair Out')}>Repair Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Reserve')}>In Reserve</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Lease Out')}>Lease Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'SCM')}>SCM</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{selectedRowData.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{selectedRowData.flight_date}</p>
                                <p><img src={Cargoplane} /></p>
                                <p>{selectedRowData.flight_number}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Destination</p>
                                <span>{selectedRowData.destination}</span>
                            </div>
                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"uld"}
                            attachable_id={selectedRowData.uld_number}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
                        />
                        <ActivityComments
                            commentable_type={"uld"}
                            commentable_id={selectedRowData.uld_number}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={loadDetails}
                        />
                        {/* <div className='mt-4'>
                            
                            
                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>

                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>

                            <div className='d-flex racomment'>
                                <div className='coment_img'><img src={Cuser} /></div>
                                <div>
                                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                                    <p>I have no reply, so i will take this ticket to next week</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                )}
            </div>

        </>
    )
}

export default LUCIn